// The script API reference shown next to the derivation editor. Keep it in
// sync with the block in docs/backend/derivations.md ("The script API").
export const SCRIPT_API_REFERENCE = `ctx.prop(path)          // a declared input: 'code', 'parent.<type>.<code>' or 'today'
ctx.props               // the declared own inputs, by code
ctx.parent(typeCode)    // { uid, name, props } of the nearest ancestor of that type, props
                        // limited to the declared parent.<type>.<code>; null when none
ctx.children(typeCode)  // [{ uid, name, type, props }] of the live descendants of that type or
                        // a subtype, any depth, ordered by created_at, uid; props limited to
                        // the declared children.<type>.<code>. Throws for a type with no
                        // declared code, and past 1,000 descendants (recorded in last_error)
ctx.asset               // { uid, name, type, depth } of the evaluated asset
ctx.today               // "YYYY-MM-DD", only when 'today' is declared
ctx.matched(priority, comment)  // which decision row answered, for provenance
// ctx.assetType, ctx.assetName, ctx.assetDepth: aliases of ctx.asset fields
// helpers: toNumber, toBoolean, trim, slugify, normalize, stripHtml,
//          eq, neq, gt, gte, lt, lte, inList, intersects, isEmpty, isSet
return value;           // null or undefined withdraws the value`
